import { type FooterLevelOneGroup, type NavItemType } from '~/vendor/cx-web/domain-types';

import FooterNavGroup from './components/FooterNavGroup/index';
import styles from './FooterNav.module.scss';

type FooterNavProps = {
  groupType: NavItemType;
  isUkFooterStyle?: boolean;
  levelOne: FooterLevelOneGroup[];
};

const shouldNotShowNav = (categoryLinks: FooterLevelOneGroup[]) => {
  return !!(!categoryLinks || !categoryLinks.length);
};

export function FooterNav({ groupType, isUkFooterStyle, levelOne }: FooterNavProps) {
  const categoryGroups = (levelOne || []).filter(item => item.type === groupType);

  if (shouldNotShowNav(categoryGroups)) return null;

  return (
    <section aria-label="Main Footer Nav Section" data-testid="footer-nav-v2">
      <nav
        aria-label="Main Footer Navigation"
        className={styles.footerNavContainer}
        data-uk-footer-style={isUkFooterStyle || undefined}
      >
        <div
          className={
            isUkFooterStyle ? `${styles.footerNavWrapper} ${styles.footerNavWrapperUk}` : styles.footerNavWrapper
          }
        >
          <ul
            className={
              isUkFooterStyle ? `${styles.footerNavGroups} ${styles.footerNavGroupsUk}` : styles.footerNavGroups
            }
          >
            {categoryGroups
              .filter(group => group.subLinks.length > 0)
              .map(props => (
                <FooterNavGroup isUkFooterStyle={isUkFooterStyle} key={props.name} {...props} />
              ))}
          </ul>
        </div>
      </nav>
    </section>
  );
}
